@let uploading = isUploading();
@let error = showInvalidTooltip() || showError();
@if (uploadedImageUrl()) {
  <div class="art-dropzone art-dropzone-uploaded">
    <div class="art-dropzone-image-wrapper">
      @if (uploadedImageUrl(); as url) {
        <img class="art-dropzone-image" [src]="url | imageUrl" alt="Uploaded Image" />
      }
      <dx-button
        class="art-dropzone-image-delete"
        type="primary-s"
        icon="delete"
        (click)="deleteImage()"
        [disabled]="uploading"
      ></dx-button>
    </div>
  </div>
} @else {
  <div
    class="art-dropzone"
    (drop)="dropHandler($event)"
    (dragover)="dragoverHandler($event)"
    (dragleave)="dragleaveHandler()"
    [class.disabled-dropzone]="uploading"
    [class.error]="error"
  >
    <art-icon [class.disabled-dropzone]="uploading" [class.error]="error" fontSize="48px">upload </art-icon>
    <dx-text class="art-dropzone-text" [class.disabled-dropzone]="uploading" [class.error]="error"
      >{{ "dropzone.label.info" | transloco }}
    </dx-text>
    @if (showInvalidTooltip()) {
      <dx-text class="tooltip">{{ "dropzone.error-message.image-count" | transloco }}</dx-text>
    }
    @if (uploading) {
      <dx-loading-indicator class="art-dropzone-loading-indicator" size="medium" label=""></dx-loading-indicator>
    }
    <input type="file" accept="image/*" (change)="prepareSelectedFileForUpload($event)" #fileInput />
  </div>
}
@if (showError()) {
  <dx-error-message>{{ errorMessage() }}</dx-error-message>
}
